/**
 * @generated SignedSource<<8d3081a94932b3ad83e6b679a3fab285>>
 * @relayHash 84e637e4ef0d68da7afb016e439ed3c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 79ba897ff5566fb8cece4c2f8823fa80501ec1a372320f5611a4a2183e69e560

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "79ba897ff5566fb8cece4c2f8823fa80501ec1a372320f5611a4a2183e69e560",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
